export const CDS_TEST_ID_DIALOG_CLOSE_BUTTON = 'CDS_TEST_ID_DIALOG_CLOSE_BUTTON';
